import React, { useState, useEffect, useRef, Fragment } from 'react';
import { DataGridPro, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, GridActionsCellItem, useGridApiRef, GridFooter } from '@mui/x-data-grid-pro';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from '@mui/material/Modal';
import { FaChevronDown } from 'react-icons/fa';
import { VscFolderActive } from 'react-icons/vsc';
import { ToastContainer } from 'react-toastify';
import { ListsModal, ObjModal } from '../../contexts';
import DisplayMessageRecips from '../../components/Modals/DisplayMessageRecips';
import ClicksInGrid from './clicks';

import EmailIcon from '@mui/icons-material/Email';
import TextsmsIcon from '@mui/icons-material/Textsms';
import ScheduleIcon from '@mui/icons-material/Schedule';
import CallIcon from '@mui/icons-material/Call';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckBoxIcon from '@mui/icons-material/CheckBox';


const toolbar = ( { selectedRows, handleMassModal } ) => {
    return(
        <GridToolbarContainer>
            <Container fluid className='p-0'>
                <Row className='p-0 align-items-center'>
                    <Col>
                        <Row className='text-start align-items-center'>
                            <Col xs='auto' className='pe-0'>
                                <GridFooter className='tf-fake-footer' />
                            </Col>
                            <Col>
                                { 
                                    selectedRows.length > 0 &&
                                    <Row style={ { borderLeft: '1px solid #CCC' } }>
                                        <Col xs='auto' className='pe-2'>Take Action...</Col>
                                        <Col xs='auto' className='ps-0'>
                                            <DropdownButton size='sm' title={<FaChevronDown />} className='tf-button-transparent tf-hide-arrow'>
                                                {/* <Dropdown.Item onClick={ () => handleMassModal( 'email-mass' ) }>Send Email</Dropdown.Item>
                                                <Dropdown.Item onClick={ () => handleMassModal( 'sms-mass' ) }>Send Txt</Dropdown.Item>
                                                <Dropdown.Divider />
                                                <Dropdown.Item onClick={ () => handleMassModal( 'list' ) }>Add to a List</Dropdown.Item>
                                                <Dropdown.Item onClick={ () => handleMassModal( 'event' ) }>Add to an Event</Dropdown.Item> */}
                                            </DropdownButton>
                                        </Col>
                                    </Row>
                                }
                            </Col>
                        </Row>
                    </Col>
                    <Col xs='auto' className='text-left'>
                        <GridToolbarQuickFilter />
                    </Col>
                </Row>
            </Container>
        </GridToolbarContainer>
    )
}

const Messages = ( { aid, uid, user, viewing, messages, comms, contacts } ) => {
    const [ gridHeight, setGridHeight ] = useState( 0 );
    const [ containerBuffer, setContainerBuffer ] = useState( 125 );

    const [ show, setShow ] = useState( false );
    const closeModal = () => setShow( false );
    const openModal = () => setShow( true );
    const [ modal, setModal ] = useState();
    const [ loading, setLoading ] = useState( true );
    const [ tList, setMessages ] = useState( [] );
    const [ selectedCid, setSelectedCid ] = useState( '' );
    const [ selectedRows, setSelectedRows ] = useState( [] );
    
    let cols = [
        { field: 'subject', headerName: 'Subject', width: 450, align: 'left', renderCell: ( params ) => <Button variant='link' size='sm' onClick={ () => handleSingleModal( 'display-recips', params.row.mid ) } style={ { whiteSpace: 'normal', textAlign: 'left', padding: 0 } }>{params.value}</Button> },
        { field: 'type', headerName: 'Msg Type', width: 100, },
        { field: 'recipients', headerName: 'Recipients', width: 100, },
        { field: 'd', headerName: 'Sent/Scheduled For', width: 200, type: 'dateTime', valueGetter: ( { value } ) => value && new Date( value.match( 'T' ) ? value : value + 'T12:00:00' ) },
        { field: 'open', headerName: 'Opened', width: 100, valueGetter: ( { value } ) => value || 0 },
        { field: 'click', headerName: 'Clicked', width: 100, valueGetter: ( { value } ) => value || 0, renderCell: ( params ) => <ClicksInGrid clicks={params.row.click} links={params.row.clickUrls} /> },
        { field: 'bounce', headerName: 'Bounced', width: 100, valueGetter: ( { value } ) => value || 0 },
        { field: 'unsubscribe', headerName: 'Unsubscribed', width: 100, valueGetter: ( { value } ) => value || 0 },
        { field: 'spam', headerName: 'Spam', width: 100, valueGetter: ( { value } ) => value || 0 },
    ];

    const containerRef = useRef();
    const titleRef = useRef();
    
    const gridRef = useGridApiRef();

    
    const handleSingleModal = ( t, mid ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'display-recips':
                console.log( 'log-call w/ cid: ' + mid );
                setModal( <DisplayMessageRecips mid={mid} /> );
                break;

            default:
                shouldOpen = false;
                console.log( 'unknown modeal type for single: ' + t + ' - ' + mid )  ;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const handleMassModal = ( t ) => {
        let shouldOpen = true;

        let contacts = [];
        selectedRows.forEach( r => {
            console.log( r );
            // const [ loid, cid ] = r.split( '#' );
            // contacts.push( leads.find( f => f.cid === cid ) );
        } );

        switch ( t ) {
            case 'email-mass':
                // setModal( <SendMassEmail contacts={ contacts } close={ closeModal } /> ); 
                break;

            case 'sms-mass':
                // setModal( <SendTxt contacts={ contacts } close={ closeModal } /> ); 
                break;
    
            case 'phoneburner':
                setModal( <div>phoneburner</div> ); 
                break;
        
            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'email':
                // setModal( <SendEmail /> );
                break;

            case 'sms':
                // setModal( <SendTxt /> );
                break;

            case 'event':
                // setModal( <AddEvent /> );
                break;

            default:
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
        
        console.log( 'modal: ' + t );
    }

    useEffect( () => {
        document.title = 'Third Floor - Messages';
    }, [] );
    
    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length > 1 ) {
            setContainerBuffer( prev => prev + 30 );
        }
    }, [ user.additionalAccounts ] );

    useEffect( () => {
        setGridHeight( containerRef.current.clientHeight - titleRef.current.clientHeight - 15 );
    }, [ containerBuffer ] );

    useEffect( () => {
        if ( messages ) {
            let list = [];
            Object.keys( messages ).forEach( mid => {
                const m = messages[mid];
                if ( !viewing.includes( m.aid ) || m.channel === 'sms' ) {
                    return;
                }
                console.log( 'msg: ', m );
                
                list.push( {
                    ...m,
                    id: m.mid,
                    type: ( m.loans || m.contacts ) ? 'Mass' : 'Direct',
                    recipients: m.loans?.length || m.contacts?.length || ( m.to?.length + m.cc?.length ),
                    details: m,
                    d: m.send || m.createdDate
                } );
            } );
            list.sort( ( a, b ) => {
                return new Date( b.d ) - new Date( a.d );
            } );
            setMessages( list );
            setLoading( false );
        }
    }, [ messages, viewing ] );

    return (
        <Container fluid className='px-0' style={ { height: '100%' } }>
            <Row className='mx-1' style={ { height: `calc(100vh - ${containerBuffer}px)` } } ref={containerRef}>
                <Col className='tf-section-container mx-2 p-0' style={ { height: '100%' } }>
                    <Row className=''>
                        <Col className=''>
                            <Row className='p-2' ref={titleRef}>
                                <Col>
                                    <VscFolderActive />
                                    <span className='ps-2 fw-bold fs-6'>Messages</span>
                                </Col>
                            </Row>
                            <Row className='p-0 m-0'>
                                <Col className='p-0' style={ { display: 'flex', height: `${gridHeight}px`, width: '100%' } }>
                                    <ListsModal.Provider value={ { openModal, closeModal, setModal } }>
                                        <DataGridPro
                                            apiRef={gridRef}
                                            loading={ loading }
                                            rows={tList}
                                            columns={cols}
                                            density='compact'
                                            checkboxSelection
                                            disableSelectionOnClick
                                            slots={ { toolbar: toolbar } }
                                            slotProps={ { toolbar: {
                                                selectedRows: selectedRows, 
                                                handleModal: handleModal, 
                                                viewing: viewing
                                            } } }
                                            onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                            getRowHeight={ () => 'auto' }
                                            sx={ {
                                                border: 0
                                            } }
                                            hideFooter={true}
                                        />
                                    </ListsModal.Provider>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <ToastContainer autoClose={3000} />
            <Modal open={show} onClose={closeModal}>
                <Fragment>{modal}</Fragment>
            </Modal>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    viewing: state.user.viewing,
    messages: state.messages.byId,
    comms: state.comms.byId,
    contacts: state.contacts.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( Messages );